export const MARK_TASK_FOR_OFFLINE = 'MARK_TASK_FOR_OFFLINE';
export const UNMARK_TASK_FOR_OFFLINE = 'UNMARK_TASK_FOR_OFFLINE';
export const SET_OFFLINE_TASKS = 'SET_OFFLINE_TASKS';
